<app-header></app-header>
<div class="breadcrumb">
  <div class="container">
    <div class="row">
      <!-- <div class="col-sm-8">
        <span><a class="cursor-link" (click)="goToTheme()">Preview</a> > <strong>Education</strong></span>
      </div> -->
    </div>
  </div>
</div>
<div class="addEducation">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="editEducation">
          <div class="editEducation__body" *ngFor="let edu of educations">
            <h5>{{edu.college}} - {{edu.degree}}
              <span mwlConfirmationPopover [popoverTitle]="'Delete Education!'" [popoverMessage]="'Are you sure?'"
                placement="left" class="editEducation__action float-right" [hidden]="edu.edit"
                (confirm)="remove(edu)"><span class="icon icon-trash"></span></span>
              <span class="editEducation__action float-right" (click)="edu.edit=true" [hidden]="edu.edit"><span
                  class="icon icon-edit"></span></span>
            </h5>
            <p>{{edu.address}} <span *ngIf="edu.branch">| </span>{{edu.branch}} <span *ngIf="edu.cgpa">|
              </span>{{edu.cgpa}} |
              <span>{{edu.start_year + ' - ' + edu.end_year}}</span>
            </p>
            <div class="row editEducation__form" *ngIf="edu.edit">
              <div class="col-sm-12">
                <div class="form-group input-group">
                  <input class="form-control form-right" ngx-google-places-autocomplete [(ngModel)]="edu.college"
                    placeholder="College Name" [options]='options'
                    (onAddressChange)="handleAddressChange($event, edu)" />
                  <input type="text" class="form-control form-right" name="degree" placeholder="Bachelor of Technology"
                    [(ngModel)]="edu.degree" required>
                </div>
                <div class="form-group input-group">
                  <input type="text" class="form-control form-left" name="field" placeholder="Field of Study"
                    [(ngModel)]="edu.branch" required>
                  <input type="text" class="form-control form-right" name="address" placeholder="Location"
                    [(ngModel)]="edu.address" required>
                </div>
                <div class="form-group input-group">
                  <input type="text" class="form-control form-left" name="field" placeholder="CGPA"
                    [(ngModel)]="edu.cgpa" required>
                  <select class="form-control select form-right form-left" [(ngModel)]="edu.start_year">
                    <option [ngValue]="0">-- Start Year --</option>
                    <option [ngValue]="1980">1980</option>
                    <option [ngValue]="1981">1981</option>
                    <option [ngValue]="1982">1982</option>
                    <option [ngValue]="1983">1983</option>
                    <option [ngValue]="1984">1984</option>
                    <option [ngValue]="1985">1985</option>
                    <option [ngValue]="1986">1986</option>
                    <option [ngValue]="1987">1987</option>
                    <option [ngValue]="1988">1988</option>
                    <option [ngValue]="1989">1989</option>
                    <option [ngValue]="1990">1990</option>
                    <option [ngValue]="1991">1991</option>
                    <option [ngValue]="1992">1992</option>
                    <option [ngValue]="1993">1993</option>
                    <option [ngValue]="1994">1994</option>
                    <option [ngValue]="1995">1995</option>
                    <option [ngValue]="1996">1996</option>
                    <option [ngValue]="1997">1997</option>
                    <option [ngValue]="1998">1998</option>
                    <option [ngValue]="1999">1999</option>
                    <option [ngValue]="2000">2000</option>
                    <option [ngValue]="2001">2001</option>
                    <option [ngValue]="2002">2002</option>
                    <option [ngValue]="2003">2003</option>
                    <option [ngValue]="2004">2004</option>
                    <option [ngValue]="2005">2005</option>
                    <option [ngValue]="2006">2006</option>
                    <option [ngValue]="2007">2007</option>
                    <option [ngValue]="2008">2008</option>
                    <option [ngValue]="2009">2009</option>
                    <option [ngValue]="2010">2010</option>
                    <option [ngValue]="2011">2011</option>
                    <option [ngValue]="2012">2012</option>
                    <option [ngValue]="2013">2013</option>
                    <option [ngValue]="2014">2014</option>
                    <option [ngValue]="2015">2015</option>
                    <option [ngValue]="2016">2016</option>
                    <option [ngValue]="2017">2017</option>
                    <option [ngValue]="2018">2018</option>
                    <option [ngValue]="2019">2019</option>
                    <option [ngValue]="2020">2020</option>
                    <option [ngValue]="2021">2021</option>
                    <option [ngValue]="2022">2022</option>
                    <option [ngValue]="2023">2023</option>
                    <option [ngValue]="2024">2024</option>
                    <option [ngValue]="2025">2025</option>
                    <option [ngValue]="2026">2026</option>
                    <option [ngValue]="2027">2027</option>
                    <option [ngValue]="2028">2028</option>
                    <option [ngValue]="2029">2029</option>
                    <option [ngValue]="2030">2030</option>
                    <option [ngValue]="2031">2031</option>
                    <option [ngValue]="2032">2032</option>
                    <option [ngValue]="2033">2033</option>
                    <option [ngValue]="2034">2034</option>
                    <option [ngValue]="2035">2035</option>
                    <option [ngValue]="2036">2036</option>
                    <option [ngValue]="2037">2037</option>
                    <option [ngValue]="2038">2038</option>
                    <option [ngValue]="2039">2039</option>
                    <option [ngValue]="2040">2040</option>
                  </select>
                  <select class="form-control select form-right" [(ngModel)]="edu.end_year">
                    <option [ngValue]="0">-- End Year --</option>
                    <option [ngValue]="1980">1980</option>
                    <option [ngValue]="1981">1981</option>
                    <option [ngValue]="1982">1982</option>
                    <option [ngValue]="1983">1983</option>
                    <option [ngValue]="1984">1984</option>
                    <option [ngValue]="1985">1985</option>
                    <option [ngValue]="1986">1986</option>
                    <option [ngValue]="1987">1987</option>
                    <option [ngValue]="1988">1988</option>
                    <option [ngValue]="1989">1989</option>
                    <option [ngValue]="1990">1990</option>
                    <option [ngValue]="1991">1991</option>
                    <option [ngValue]="1992">1992</option>
                    <option [ngValue]="1993">1993</option>
                    <option [ngValue]="1994">1994</option>
                    <option [ngValue]="1995">1995</option>
                    <option [ngValue]="1996">1996</option>
                    <option [ngValue]="1997">1997</option>
                    <option [ngValue]="1998">1998</option>
                    <option [ngValue]="1999">1999</option>
                    <option [ngValue]="2000">2000</option>
                    <option [ngValue]="2001">2001</option>
                    <option [ngValue]="2002">2002</option>
                    <option [ngValue]="2003">2003</option>
                    <option [ngValue]="2004">2004</option>
                    <option [ngValue]="2005">2005</option>
                    <option [ngValue]="2006">2006</option>
                    <option [ngValue]="2007">2007</option>
                    <option [ngValue]="2008">2008</option>
                    <option [ngValue]="2009">2009</option>
                    <option [ngValue]="2010">2010</option>
                    <option [ngValue]="2011">2011</option>
                    <option [ngValue]="2012">2012</option>
                    <option [ngValue]="2013">2013</option>
                    <option [ngValue]="2014">2014</option>
                    <option [ngValue]="2015">2015</option>
                    <option [ngValue]="2016">2016</option>
                    <option [ngValue]="2017">2017</option>
                    <option [ngValue]="2018">2018</option>
                    <option [ngValue]="2019">2019</option>
                    <option [ngValue]="2020">2020</option>
                    <option [ngValue]="2021">2021</option>
                    <option [ngValue]="2022">2022</option>
                    <option [ngValue]="2023">2023</option>
                    <option [ngValue]="2024">2024</option>
                    <option [ngValue]="2025">2025</option>
                    <option [ngValue]="2026">2026</option>
                    <option [ngValue]="2027">2027</option>
                    <option [ngValue]="2028">2028</option>
                    <option [ngValue]="2029">2029</option>
                    <option [ngValue]="2030">2030</option>
                    <option [ngValue]="2031">2031</option>
                    <option [ngValue]="2032">2032</option>
                    <option [ngValue]="2033">2033</option>
                    <option [ngValue]="2034">2034</option>
                    <option [ngValue]="2035">2035</option>
                    <option [ngValue]="2036">2036</option>
                    <option [ngValue]="2037">2037</option>
                    <option [ngValue]="2038">2038</option>
                    <option [ngValue]="2039">2039</option>
                    <option [ngValue]="2040">2040</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12">
                <button class="btn btn-success" (click)="edit(edu)">Save &amp; Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="addMore">
      <div class="col-lg-7 col-sm-6">
        <h2>Add Education</h2>
        <div class="form-group input-group">
          <input class="form-control form-right" ngx-google-places-autocomplete [(ngModel)]="newEdu.college"
            placeholder="College Name" [options]='options' (onAddressChange)="handleAddressChange($event, newEdu)" />
          <input type="text" class="form-control form-right" name="degree" placeholder="Bachelor of Technology"
            [(ngModel)]="newEdu.degree" required>
        </div>
        <div class="form-group input-group">
          <input type="text" class="form-control form-left" name="field" placeholder="Field of Study"
            [(ngModel)]="newEdu.branch" required>
          <input type="text" class="form-control form-right" name="address" placeholder="Location"
            [(ngModel)]="newEdu.address" required>
        </div>
        <div class="form-group input-group">
          <input type="text" class="form-control form-left" name="field" placeholder="CGPA" [(ngModel)]="newEdu.cgpa"
            required>
          <select class="form-control select form-right form-left" [(ngModel)]="newEdu.start_year">
            <option [ngValue]="null">-- Start Year --</option>
            <option [ngValue]="2040">2040</option>
            <option [ngValue]="2039">2039</option>
            <option [ngValue]="2038">2038</option>
            <option [ngValue]="2037">2037</option>
            <option [ngValue]="2036">2036</option>
            <option [ngValue]="2035">2035</option>
            <option [ngValue]="2034">2034</option>
            <option [ngValue]="2033">2033</option>
            <option [ngValue]="2032">2032</option>
            <option [ngValue]="2031">2031</option>
            <option [ngValue]="2030">2030</option>
            <option [ngValue]="2029">2029</option>
            <option [ngValue]="2028">2028</option>
            <option [ngValue]="2027">2027</option>
            <option [ngValue]="2026">2026</option>
            <option [ngValue]="2025">2025</option>
            <option [ngValue]="2024">2024</option>
            <option [ngValue]="2023">2023</option>
            <option [ngValue]="2022">2022</option>
            <option [ngValue]="2021">2021</option>
            <option [ngValue]="2020">2020</option>
            <option [ngValue]="2019">2019</option>
            <option [ngValue]="2018">2018</option>
            <option [ngValue]="2017">2017</option>
            <option [ngValue]="2016">2016</option>
            <option [ngValue]="2015">2015</option>
            <option [ngValue]="2014">2014</option>
            <option [ngValue]="2013">2013</option>
            <option [ngValue]="2012">2012</option>
            <option [ngValue]="2011">2011</option>
            <option [ngValue]="2010">2010</option>
            <option [ngValue]="2009">2009</option>
            <option [ngValue]="2008">2008</option>
            <option [ngValue]="2007">2007</option>
            <option [ngValue]="2006">2006</option>
            <option [ngValue]="2005">2005</option>
            <option [ngValue]="2004">2004</option>
            <option [ngValue]="2003">2003</option>
            <option [ngValue]="2002">2002</option>
            <option [ngValue]="2001">2001</option>
            <option [ngValue]="2000">2000</option>
            <option [ngValue]="1999">1999</option>
            <option [ngValue]="1998">1998</option>
            <option [ngValue]="1997">1997</option>
            <option [ngValue]="1996">1996</option>
            <option [ngValue]="1995">1995</option>
            <option [ngValue]="1994">1994</option>
            <option [ngValue]="1993">1993</option>
            <option [ngValue]="1992">1992</option>
            <option [ngValue]="1991">1991</option>
            <option [ngValue]="1990">1990</option>
            <option [ngValue]="1989">1989</option>
            <option [ngValue]="1988">1988</option>
            <option [ngValue]="1987">1987</option>
            <option [ngValue]="1986">1986</option>
            <option [ngValue]="1985">1985</option>
            <option [ngValue]="1984">1984</option>
            <option [ngValue]="1983">1983</option>
            <option [ngValue]="1982">1982</option>
            <option [ngValue]="1981">1981</option>
            <option [ngValue]="1980">1980</option>
            <option [ngValue]="1979">1979</option>
            <option [ngValue]="1978">1978</option>
            <option [ngValue]="1977">1977</option>
            <option [ngValue]="1976">1976</option>
            <option [ngValue]="1975">1975</option>
            <option [ngValue]="1974">1974</option>
            <option [ngValue]="1973">1973</option>
            <option [ngValue]="1972">1972</option>
            <option [ngValue]="1971">1971</option>
            <option [ngValue]="1970">1970</option>
          </select>
          <select class="form-control select form-right" [(ngModel)]="newEdu.end_year">
            <option [ngValue]="null">-- End Year --</option>
            <option [ngValue]="2040">2040</option>
            <option [ngValue]="2039">2039</option>
            <option [ngValue]="2038">2038</option>
            <option [ngValue]="2037">2037</option>
            <option [ngValue]="2036">2036</option>
            <option [ngValue]="2035">2035</option>
            <option [ngValue]="2034">2034</option>
            <option [ngValue]="2033">2033</option>
            <option [ngValue]="2032">2032</option>
            <option [ngValue]="2031">2031</option>
            <option [ngValue]="2030">2030</option>
            <option [ngValue]="2029">2029</option>
            <option [ngValue]="2028">2028</option>
            <option [ngValue]="2027">2027</option>
            <option [ngValue]="2026">2026</option>
            <option [ngValue]="2025">2025</option>
            <option [ngValue]="2024">2024</option>
            <option [ngValue]="2023">2023</option>
            <option [ngValue]="2022">2022</option>
            <option [ngValue]="2021">2021</option>
            <option [ngValue]="2020">2020</option>
            <option [ngValue]="2019">2019</option>
            <option [ngValue]="2018">2018</option>
            <option [ngValue]="2017">2017</option>
            <option [ngValue]="2016">2016</option>
            <option [ngValue]="2015">2015</option>
            <option [ngValue]="2014">2014</option>
            <option [ngValue]="2013">2013</option>
            <option [ngValue]="2012">2012</option>
            <option [ngValue]="2011">2011</option>
            <option [ngValue]="2010">2010</option>
            <option [ngValue]="2009">2009</option>
            <option [ngValue]="2008">2008</option>
            <option [ngValue]="2007">2007</option>
            <option [ngValue]="2006">2006</option>
            <option [ngValue]="2005">2005</option>
            <option [ngValue]="2004">2004</option>
            <option [ngValue]="2003">2003</option>
            <option [ngValue]="2002">2002</option>
            <option [ngValue]="2001">2001</option>
            <option [ngValue]="2000">2000</option>
            <option [ngValue]="1999">1999</option>
            <option [ngValue]="1998">1998</option>
            <option [ngValue]="1997">1997</option>
            <option [ngValue]="1996">1996</option>
            <option [ngValue]="1995">1995</option>
            <option [ngValue]="1994">1994</option>
            <option [ngValue]="1993">1993</option>
            <option [ngValue]="1992">1992</option>
            <option [ngValue]="1991">1991</option>
            <option [ngValue]="1990">1990</option>
            <option [ngValue]="1989">1989</option>
            <option [ngValue]="1988">1988</option>
            <option [ngValue]="1987">1987</option>
            <option [ngValue]="1986">1986</option>
            <option [ngValue]="1985">1985</option>
            <option [ngValue]="1984">1984</option>
            <option [ngValue]="1983">1983</option>
            <option [ngValue]="1982">1982</option>
            <option [ngValue]="1981">1981</option>
            <option [ngValue]="1980">1980</option>
            <option [ngValue]="1979">1979</option>
            <option [ngValue]="1978">1978</option>
            <option [ngValue]="1977">1977</option>
            <option [ngValue]="1976">1976</option>
            <option [ngValue]="1975">1975</option>
            <option [ngValue]="1974">1974</option>
            <option [ngValue]="1973">1973</option>
            <option [ngValue]="1972">1972</option>
            <option [ngValue]="1971">1971</option>
            <option [ngValue]="1970">1970</option>
          </select>
        </div>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-3 col-sm-6">
        <div class="addEducation__bg">
          <img src="../../../../assets/images/resume_{{theme_id}}.jpg" class="img-fluid addEducation__img" />
          <div class="addEducation__overlay"></div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-12">
        <div class="addEducation__buttons">
          <button class="btn btn-default" routerLink="/resume/summary">Back</button>
          <button class="btn btn-default" routerLink="/resume/exp">Skip</button>
          <button class="btn btn-primary" *ngIf="addMore" (click)="add()">Save &amp; Next</button>
          <button class="btn btn-primary" (click)="addMore=true" [hidden]="addMore">Add Another</button>
        </div>
      </div>
      <!-- <div class="col-sm-6 col-8 text-right">
        <div class="addEducation__buttons">
          <button class="btn btn-default" routerLink="/resume/exp">Skip</button>
          <button class="btn btn-primary" *ngIf="addMore" (click)="add()">Save &amp; Next</button>
          <button class="btn btn-primary" (click)="addMore=true" [hidden]="addMore">Add Another</button>
        </div>
      </div> -->
    </div>
  </div>
</div>
<app-footer></app-footer>